<!-- <template>
<svg
	:id="id"
	viewBox="0 0 50 50"
	:width="width"
	:height="height"
	>
</svg>
</template> -->
<script>
import { select, arc, scaleOrdinal, pie, interpolate, interpolateRound } from 'd3';
var tau = 2 * Math.PI;
export default {
  name: 'donut-progress',
  props: ['width', 'height', 'chartData', 'colours', 'label', 'id'],
  mounted() {
    this.svg = select('#' + this.id)
    this.totalPc = this.label
    this.$nextTick(function() {
      this.draw();
    });
  },
  render(h) {
    return h('svg', {
      attrs: {
        id: this.id,
        width: this.width,
        height: this.height,
        viewBox: "0 0 50 50"
      }
    }, []);
  },
  watch: {
    chartData(oldVal, val) {
      if (this.chartData.total != 0)
        this.$nextTick(function() {
          this.redraw(oldVal, val);
        });
    }
  },
  methods: {
    draw() {
      var self = this;
      this.g = this.svg.append("g").attr("transform", "translate(25,25)");
      this.arc = arc().innerRadius(50 / 3).outerRadius(50 / 2);
      var color = scaleOrdinal(this.colours)
      this.pie = pie()
        .sort(null)
        .value(function(d) { return d.val; });

      this.background = this.g.append("path")
        .datum({ startAngle: 0, endAngle: tau })
        .style("fill", "#ddd")
        .attr("d", this.arc);

      this.chart_label = this.svg.append("text")
        .text(Math.round(this.label) + '%')
        .attr("font-size", "10px")
        .attr("transform", "translate(25,29)")
        .style("text-anchor", "middle");
      this.chart = this.g.datum(this.chartData).selectAll("path.arc")
        .data(this.pie).enter()
        .append("path")
        .attr("class", "arc")
        .attr("fill", function(d, i) { return color(i); })
        .attr("d", this.arc)
      // store the initial angles
    },
    redraw() {
      var self = this;
      this.chart = this.chart.data(this.pie(this.chartData)); // compute the new angles
      // this.chart_label = this.chart_label.data(this.pie(this.chartData)); // compute the new angles

      this.chart_label
        .text(this.totalPc)
        .transition()
        .duration(750)
        .tween('text', tweenText(this.label));

      this.chart
        .transition()
        .duration(750)
        .attrTween("d", arcTween); // redraw the arcs

      function arcTween(a) {
        var i = interpolate(this._current, a);
        this._current = i(0);
        return function(t) {
          return self.arc(i(t));
        };
      }

      function tweenText(newValue) {
        return function() {
          var currentValue = +self.chart_label.text().replace('%', '');
          var i = interpolateRound(currentValue, newValue);
          return function(t) {
            self.chart_label.text(i(t) + '%');
          };
        }
      }
    },

  }

}

</script>
